import { defineNuxtPlugin } from "nuxt/app";
import * as Sentry from '@sentry/vue';

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig().public.sentry;

  // Memo
  // 公式のドキュメントに従って初期化
  // https://docs.sentry.io/platforms/javascript/guides/vue/

  // sourceMapのuploadはCI/CDでbuild時に行うようにしています。
  // 参考: https://docs.sentry.io/platforms/javascript/guides/vue/sourcemaps/uploading/cli/
  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: config.dsn,
    environment: config.environment,
    release: config.release,
    integrations: [
      Sentry.browserTracingIntegration({ router: nuxtApp.$router }),
      Sentry.replayIntegration(),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/user-api-stg\.attelu\.com\/v1/,
      /^https:\/\/api-stg\.attelu\.com\/api\/v1/,
      /^https:\/\/user-api\.attelu\.com\/v1/,
      /^https:\/\/api\.attelu\.com\/api\/v1/,
    ],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    // 500エラー以外のノイズとなるエラーを減らすため40xエラーはフィルターする
    ignoreErrors: [
      'Error: Request failed with status code 400',
      'Error: Request failed with status code 401',
      'Error: Request failed with status code 404'
    ],
  });
  nuxtApp.provide('sentry', Sentry);
});
